import type { Subtodo } from 'owa-todo-types';

/**
 * Gets the difference, including duplicates, between the array of allSubtasks to be created and
 * the successfully created subtasks.
 * @param allSubtasks all subtasks intended to be created
 * @param createdSubtasks subtasks that were successfully created. This should always be a subset
 * of allSubtasks
 */
export default function getUnsuccessfullyCreatedSubtasks(
    allSubtasks: Partial<Subtodo>[],
    createdSubtasks: Partial<Subtodo>[]
): Partial<Subtodo>[] {
    const uncreatedSubtasks: Partial<Subtodo>[] = [];
    const subtaskCountMap = new Map<string, number>();
    allSubtasks.reduce(
        (subtaskCountMap, subtask) =>
            subtaskCountMap.set(subtask.Subject!, (subtaskCountMap.get(subtask.Subject!) || 0) + 1),
        subtaskCountMap
    );
    createdSubtasks.reduce(
        (subtaskCountMap, createdSubtask) =>
            subtaskCountMap.set(
                createdSubtask.Subject!,
                (subtaskCountMap.get(createdSubtask.Subject!) || 0) - 1
            ),
        subtaskCountMap
    );

    subtaskCountMap.forEach((count: number, key: string) => {
        if (count && count > 0) {
            for (let i = 0; i < count; i++) {
                uncreatedSubtasks.push({ Subject: key });
            }
        }
    });

    return uncreatedSubtasks;
}
